"use client";

import { RefObject } from "react";
import type { Swiper as SwiperType } from "swiper";

export function CarouselCenteredProgress({
  activeIndex,
  totalSlides,
  swiperRef,
  showPagedProgress,
}: CarouselCenteredProgressProps) {
  if (totalSlides <= 0) return null;

  const current = Math.min(activeIndex + 1, totalSlides);

  return (
    <>
      {!showPagedProgress ? (
        <div
          className="bg-greyscale-strength/30 h-1 w-full max-w-[60px] overflow-hidden rounded-full"
          role="progressbar"
          aria-valuemin={1}
          aria-valuemax={totalSlides}
          aria-valuenow={current}
          aria-label={`Slide ${current} of ${totalSlides}`}>
          <div
            data-testid="carousel-progress-thumb"
            className="bg-secondary h-full rounded-full transition-all duration-300"
            style={{
              width: `${(current / totalSlides) * 100}%`,
            }}
          />
        </div>
      ) : (
        <div className="flex justify-between">
          {Array.from({ length: totalSlides }).map((_, i) => {
            if (activeIndex === i) {
              return (
                <div
                  key={i}
                  className="mx-0.5 h-2 w-2 rounded-xl bg-gray-700"></div>
              );
            } else {
              return (
                <a
                  className="cursor-pointer"
                  onClick={() => swiperRef?.current?.slideTo(i + 1)}
                  key={i}>
                  <div
                    key={i}
                    className="mx-0.5 h-2 w-2 rounded-xl bg-gray-500"></div>
                </a>
              );
            }
          })}
        </div>
      )}
    </>
  );
}

export type CarouselCenteredProgressProps = {
  activeIndex: number;
  totalSlides: number;
  swiperRef?: RefObject<SwiperType | null>;
  showPagedProgress?: boolean;
};
